<template>
  <div
    class="main-article main-article__vue-element"
  />
</template>

<script>

/**
 * Vue: Main article (main-article)
 * -----------------------------------------------------------------------------
 * Article page section.
 * - Static section.
 *
 */
export default {
  name: 'MainArticle',
  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {
      container: null,
    }
  },

  mounted() {
    this.container = document.querySelector(`#vue-element .section-${this.liquid.sectionId}`)
    this.formatIframes()
    this.formatImages()
  },

  methods: {

    /**
     * Format iframes
     * - Wrap iframes in a div to make them responsive.
     */
    formatIframes() {
      const iframes = this.container.querySelectorAll('iframe')

      if (!iframes || iframes.legnth === 0) {
        return
      }

      iframes.forEach((iframe) => {
        const iframeParent = iframe.parentNode
        const iframeWrapper = document.createElement('div')

        iframeWrapper.classList.add('main-article__iframe')
        iframeWrapper.appendChild(iframe)
        iframeParent.appendChild(iframeWrapper)

        iframe.height = '100%'
        iframe.width = '100%'
      })
    },

    /**
     * Format images
     * - Wrap images in a div and normalize spacing.
     */
    formatImages() {
      const images = this.container.querySelectorAll('img')

      if (!images || images.length === 0) {
        return
      }

      images.forEach((image) => {
        const imageParent = image.parentNode
        const imageFloat = image.style.float
        imageParent.classList.add('main-article__image-container')
        if (imageFloat === 'left' || imageFloat === 'right') {
          if (image.style.marginLeft || image.style.marginRight) {
            return
          }

          image.style.float = 'none'
          imageParent.classList.add(`main-article__image-container--${imageFloat}`)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import './main-article';
</style>
